'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _allenfangReactBootstrapTable = require('allenfang-react-bootstrap-table');

var _SortUtil = require('../../../utils/SortUtil');

var _Checkbox = require('../../checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ClearableInput = require('../../clearableInput/ClearableInput');

var _ClearableInput2 = _interopRequireDefault(_ClearableInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STOPPING_NODES = ['A', 'BUTTON', 'INPUT', 'LABEL'];
var STOPPING_CLASSES = ['btn'];

var RioBootstrapTable = function (_Component) {
    (0, _inherits3.default)(RioBootstrapTable, _Component);

    /* istanbul ignore next */
    function RioBootstrapTable(props) {
        (0, _classCallCheck3.default)(this, RioBootstrapTable);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RioBootstrapTable.__proto__ || Object.getPrototypeOf(RioBootstrapTable)).call(this, props));

        var selectedElements = _this.getSelectedElements();

        /* Note: tableHeaderSortOrder - We use 'undefined' here so that the original
         * implementation of react-bootstrap-table will control the sort order
         * (either 'asc' or 'desc') and render the caret appropriately. */
        _this.state = (0, _extends3.default)({}, _this.state, {
            selectedElements: selectedElements,
            selectedElementsOld: [],
            renderData: _this.props.data,
            tableHeaderSortOrder: undefined
        });

        _this.tableSelectionBehavior = {
            className: 'active',
            columnWidth: '30px',
            onSelect: _this.onSelect.bind(_this)
        };
        return _this;
    }

    (0, _createClass3.default)(RioBootstrapTable, [{
        key: 'getSelectedElements',
        value: function getSelectedElements() {
            var _this2 = this;

            if (this.props.selectedElements) {
                return this.props.selectedElements.filter(function (id) {
                    return _this2.props.data.findIndex(function (el) {
                        return (0, _lodash.isEqual)(el[_this2.props.keyField], id);
                    }) !== -1;
                });
            }
            return [];
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var options = this.props.options;

            // trigger initial sorting in case it has been set externally
            if (options && options.defaultSortName && options.defaultSortOrder) {
                this.onSortChange(options.defaultSortName, options.defaultSortOrder);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!(0, _lodash.isEqual)(this.props.data, nextProps.data) || !(0, _lodash.isEqual)(this.props.selectedElements, nextProps.selectedElements)) {
                var selectedElements = this.state.selectedElements;
                if (nextProps.selectedElements) {
                    selectedElements = nextProps.selectedElements.filter(function (id) {
                        return nextProps.data.findIndex(function (el) {
                            return (0, _lodash.isEqual)(el[nextProps.keyField], id);
                        }) !== -1;
                    });
                }
                this.setState({
                    selectedElements: selectedElements,
                    selectedElementsOld: this.props.selectedElements ? this.props.selectedElements : this.state.selectedElementsOld,
                    renderData: (0, _lodash.isEqual)(this.props.data, nextProps.data) ? this.state.renderData : nextProps.data
                });
            }
        }
    }, {
        key: 'createTableViewElements',
        value: function createTableViewElements() {
            var elements = this.state.renderData;
            var selectedElements = this.state.selectedElements ? this.state.selectedElements : [];
            var unSelectableElements = this.props.unSelectableElements ? this.props.unSelectableElements : [];
            var keyField = this.props.keyField;
            var tableViewElements = elements.map(function (element, index) {
                return (0, _extends3.default)({}, element, {
                    originalElement: element,
                    tableRowKey: index,
                    isSelected: selectedElements.findIndex(function (el) {
                        return (0, _lodash.isEqual)(el, element[keyField]);
                    }) !== -1,
                    unselectable: unSelectableElements.findIndex(function (el) {
                        return (0, _lodash.isEqual)(el, element[keyField]);
                    }) !== -1
                });
            });
            return tableViewElements;
        }
    }, {
        key: 'getTableSelectionBehaviour',
        value: function getTableSelectionBehaviour(tableViewElements) {
            var selectionBehavior = (0, _extends3.default)({}, this.tableSelectionBehavior, {
                clickToSelect: this.props.clickToSelect,
                selected: tableViewElements.filter(function (element) {
                    return element.isSelected;
                }).map(function (filteredElement) {
                    return filteredElement.tableRowKey;
                }),
                unselectable: tableViewElements.filter(function (element) {
                    return element.unselectable;
                }).map(function (filteredElement) {
                    return filteredElement.tableRowKey;
                })
            });

            if (this.props.singleSelect) {
                return (0, _extends3.default)({}, selectionBehavior, {
                    mode: 'radio',
                    hideSelectColumn: true
                });
            }

            return (0, _extends3.default)({}, selectionBehavior, {
                onSelectAll: this.onSelectAll.bind(this),
                mode: 'checkbox',
                customComponent: this.customMultiSelect.bind(this)
            });
        }
    }, {
        key: 'customMultiSelect',
        value: function customMultiSelect(props) {
            var isNewSelected = props.rowIndex === 'Header' ? false : this.state.selectedElementsOld.indexOf(this.state.renderData[props.rowIndex][this.props.keyField]) === -1;
            return _react2.default.createElement(
                'div',
                { className: 'checkboxWrapper' },
                _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({}, props, {
                    className: isNewSelected ? '' : 'no-animation',
                    onClick:
                    /* istanbul ignore next */
                    function onClick() {/* ignore */} }))
            );
        }
    }, {
        key: 'onSelect',
        value: function onSelect(row, isSelected, event) {
            // rejects on STOPPING - tags or classes

            if (event.type === 'click') {
                var hasWrongClass = STOPPING_CLASSES.some(function (className) {
                    event.target.classList.contains(className);
                });

                if (STOPPING_NODES.indexOf(event.target.nodeName) !== -1 || hasWrongClass || event.defaultPrevented) {
                    return false;
                }
            }

            row.isSelected = isSelected;
            var selectedElementsOld = this.state.selectedElements;
            var selectedElementsNew = this.updateArrayOfSelectedElements([row], isSelected, selectedElementsOld);
            if (this.props.onSelectionChange) {
                this.props.onSelectionChange(selectedElementsNew, selectedElementsOld);
            }
        }
    }, {
        key: 'onSelectAll',
        value: function onSelectAll(isSelected, rows) {
            rows.forEach(function (element) {
                element.isSelected = isSelected;
            });
            var selectedElementsOld = this.state.selectedElements.slice();
            var selectedElementsNew = this.updateArrayOfSelectedElements(rows, isSelected, selectedElementsOld);
            if (this.props.onSelectionChange) {
                this.props.onSelectionChange(selectedElementsNew, selectedElementsOld);
            }
        }
    }, {
        key: 'updateArrayOfSelectedElements',
        value: function updateArrayOfSelectedElements(rows, isSelected, selectedElementsOld) {
            var selectedElements = this.state.selectedElements.slice();
            if (selectedElements) {
                var keyField = this.props.keyField;
                if (this.props.singleSelect) {
                    selectedElements = [];
                }
                rows.forEach(function (row) {
                    var index = selectedElements.findIndex(function (el) {
                        return (0, _lodash.isEqual)(el, row.originalElement[keyField]);
                    });
                    if (isSelected) {
                        if (index === -1) {
                            selectedElements.push(row.originalElement[keyField]);
                        }
                    } else if (index !== -1) {
                        selectedElements.splice(index, 1);
                    }
                });
                this.setState({
                    selectedElements: this.props.selectedElements ? this.props.selectedElements : selectedElements,
                    selectedElementsOld: selectedElementsOld
                });
                return selectedElements;
            }
            return [];
        }
    }, {
        key: 'sortFunc',
        value: function sortFunc(a, b, order, sortField /*, extraData*/) {
            var sortedData = this.doCustomSorting(sortField, order);
            var sortedFields = sortedData.map(function (dataEntry) {
                return dataEntry[sortField];
            });
            var indexA = sortedFields.indexOf(a[sortField]);
            var indexB = sortedFields.indexOf(b[sortField]);

            return indexA < indexB ? -1 : 1;
        }
    }, {
        key: 'onSortChange',
        value: function onSortChange(sortName, sortOrder) {
            this.setState({
                tableHeaderSortOrder: undefined // enable caret again
            });

            var sortedData = this.doCustomSorting(sortName, sortOrder);
            this.setState({
                renderData: sortedData
            });
        }
    }, {
        key: 'doCustomSorting',
        value: function doCustomSorting(sortName, sortOrder) {
            return this.props.customSort ? this.props.customSort(sortName, sortOrder) : (0, _SortUtil.sortByProperty)(this.props.data, sortName, sortOrder, this.props.isCaseSensitiv);
        }
    }, {
        key: 'getCustomSearchPanel',
        value: function getCustomSearchPanel(_ref) {
            var _this3 = this;

            var defaultValue = _ref.defaultValue,
                placeholder = _ref.placeholder,
                search = _ref.search;

            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-group' },
                    _react2.default.createElement(
                        'span',
                        { className: 'input-group-addon' },
                        _react2.default.createElement('span', { className: 'rioglyph rioglyph-search', 'aria-hidden': 'true' })
                    ),
                    _react2.default.createElement(_ClearableInput2.default, {
                        defaultValue: defaultValue,
                        onChange: function onChange(str) {
                            search(str);

                            // resorts data
                            _this3.setState({ selectedElements: _this3.state.selectedElements });
                        },
                        placeholder: placeholder
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var tableViewElements = this.createTableViewElements();

            var customProps = (0, _extends3.default)({}, this.props, {
                data: tableViewElements,
                keyField: 'tableRowKey',
                tableHeaderClass: '',
                tableBodyClass: '',
                tableContainerClass: 'rio-bs-table',
                selectRow: this.props.enableRowSelection && this.state.renderData.length ? this.getTableSelectionBehaviour(tableViewElements) : undefined,
                options: (0, _extends3.default)({}, this.props.options, {
                    onSortChange: this.props.options && this.props.options.onSortChange ? this.props.options.onSortChange : this.onSortChange.bind(this),
                    searchPanel: this.getCustomSearchPanel.bind(this)
                }),
                headerContainerClass: this.props.stickyPosition ? 'sticky-position' : '',
                headerStyle: { top: this.props.stickyPositionOffset }
            });

            /* For some of the props of react-bootstrap-table default values are defined. Unfortunately, these default props
             * will be used in our special case where we want the render() method to render {this.props.children}, and there
             * is no possibility to override these default props.
             * Therefore, we clone all child elements and set those properties with our needed values right here instead of
             * in the render() method of RioTableHeaderColumn where it is supposed to be. */
            var childrenToRender = _react2.default.Children.map(this.props.children, function (child) {
                if (child.props.hidden) {
                    //react-bootstrap-table hidden columns not working correctly
                    return;
                }

                return (0, _extends3.default)({}, child, {
                    props: (0, _extends3.default)({}, child.props, {
                        sortFunc: child.props.sortFunc ? child.props.sortFunc : _this4.sortFunc.bind(_this4),
                        sortOrder: _this4.state.tableHeaderSortOrder
                    })
                });
            });

            return _react2.default.createElement(
                _allenfangReactBootstrapTable.BootstrapTable,
                customProps,
                childrenToRender
            );
        }
    }]);
    return RioBootstrapTable;
}(_react.Component);

exports.default = RioBootstrapTable;


RioBootstrapTable.defaultProps = {
    searchPlaceholder: 'Search table ...',
    striped: false,
    hover: true,
    options: {
        noDataText: 'No data found.'
    }
};

RioBootstrapTable.propTypes = (0, _extends3.default)({}, _allenfangReactBootstrapTable.BootstrapTable.propTypes, {
    selectedElements: _propTypes2.default.array,
    unSelectableElements: _propTypes2.default.array,
    enableRowSelection: _propTypes2.default.bool,
    onSelectionChange: _propTypes2.default.func,
    clickToSelect: _propTypes2.default.bool,
    customSort: _propTypes2.default.func,
    isCaseSensitiv: _propTypes2.default.bool,
    singleSelect: _propTypes2.default.bool,
    keyField: _propTypes2.default.string.isRequired,
    striped: _propTypes2.default.bool,
    hover: _propTypes2.default.bool,
    stickyPosition: _propTypes2.default.bool,
    stickyPositionOffset: _propTypes2.default.string
});